import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-btn-camera',
  templateUrl: './btn-camera.component.html',
  styleUrls: ['./btn-camera.component.scss']
})
export class BtnCameraComponent implements OnInit {
  @Input() status: boolean = true;
  
  constructor() { }

  ngOnInit() {
  }

}
